// Generador de hiloramas en la nube (solo administradores).
//
// La foto se encuadra en el navegador (igual que el generador clásico), se le
// aplican brillo y contraste, y se manda a la Cloud Function generarStringArt
// (codebase "stringart", Python). Dos de las variantes pasan antes por Gemini
// (fondoGemini) para dejar el fondo liso blanco o gris oscuro.
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

const generarStringArtFn = httpsCallable(functions, "generarStringArt", { timeout: 300000 });
const fondoGeminiFn = httpsCallable(functions, "fondoGemini", { timeout: 120000 });

export const VARIANTES_NUBE = [
  { id: "normal", label: "FOTO NORMAL",  fondo: null     },
  { id: "blanco", label: "FONDO BLANCO", fondo: "blanco" },
  { id: "gris",   label: "FONDO GRIS",   fondo: "gris"   },
];

// Qué calidades se piden. "ambas" pide primero normal (sale rápido) y después
// máxima, que sustituye a la normal cuando llega.
export const CALIDADES_NUBE = [
  { id: "normal", label: "Normal", etapas: ["normal"] },
  { id: "maxima", label: "Máxima", etapas: ["maxima"] },
  { id: "ambas",  label: "Normal + máxima", etapas: ["normal", "maxima"] },
];

// Segundos estimados por etapa (según las pruebas de la función). La primera
// llamada tras un rato sin uso arranca en frío y tarda bastante más.
export const ESTIMADO = { gemini: 15, normal: 15, maxima: 30 };
export const ARRANQUE_FRIO = 25;

let funcionCaliente = false;
export const nubeCaliente = () => funcionCaliente;

/**
 * Recorte cuadrado de lo que se ve en el círculo, con brillo y contraste
 * aplicados a los píxeles (misma fórmula y orden que el filtro CSS
 * `brightness() contrast()` con el que se previsualiza). Fondo blanco donde la
 * foto no llega. Devuelve un data URL JPG.
 */
export function recorteAjustado(img, transform, { brillo = 100, contraste = 100 }, canvasLogico, size = 1024) {
  const c = document.createElement("canvas");
  c.width = size; c.height = size;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, size, size);
  const scale = size / canvasLogico;
  const w = img.width * transform.zoom * scale;
  const h = img.height * transform.zoom * scale;
  ctx.save();
  ctx.translate(size / 2, size / 2);
  ctx.rotate((transform.rot * Math.PI) / 180);
  ctx.translate(transform.x * scale, transform.y * scale);
  ctx.drawImage(img, -w / 2, -h / 2, w, h);
  ctx.restore();

  if (brillo !== 100 || contraste !== 100) {
    const b = brillo / 100, k = contraste / 100;
    const lut = new Uint8ClampedArray(256);
    for (let v = 0; v < 256; v++) lut[v] = Math.round((((v / 255) * b - 0.5) * k + 0.5) * 255);
    const datos = ctx.getImageData(0, 0, size, size);
    const p = datos.data;
    for (let i = 0; i < p.length; i += 4) {
      p[i] = lut[p[i]]; p[i + 1] = lut[p[i + 1]]; p[i + 2] = lut[p[i + 2]];
    }
    ctx.putImageData(datos, 0, 0);
  }
  return c.toDataURL("image/jpeg", 0.92);
}

// Gemini puede devolver otro tamaño o un PNG pesado: se normaliza a un JPG
// cuadrado (recorte centrado) antes de mandarlo a la función de string art.
function aCuadradoJpg(dataUrl, size = 1024) {
  return new Promise((resolve, reject) => {
    const im = new Image();
    im.onload = () => {
      const lado = Math.min(im.width, im.height);
      const c = document.createElement("canvas");
      c.width = size; c.height = size;
      c.getContext("2d").drawImage(im, (im.width - lado) / 2, (im.height - lado) / 2, lado, lado, 0, 0, size, size);
      resolve(c.toDataURL("image/jpeg", 0.92));
    };
    im.onerror = () => reject(new Error("Gemini devolvió una imagen que no se pudo leer"));
    im.src = dataUrl;
  });
}

export async function quitarFondoGemini(imagen, fondo) {
  const { data } = await fondoGeminiFn({ imagen, fondo });
  return aCuadradoJpg(data.imagen);
}

/** Devuelve { sequence, segundos, lineas, metros } o lanza el error de la función. */
export async function generarEnNube(imagen, { calidad, clavos, diametro, grosor, nombre }) {
  const { data } = await generarStringArtFn({
    imagen, calidad, clavos, diametro, grosor, nombre,
    hilos: 0,            // automático
    centrar: false,      // el encuadre ya viene hecho desde la app
    quitarFondo: false,  // el fondo lo resuelve Gemini en sus variantes
    contraste: true,
    guardar: false,      // se guarda solo la que el usuario elija
  });
  funcionCaliente = true;
  const s = data.secuencia;
  return { sequence: s.Chain, segundos: data.segundos, lineas: s.Strings, metros: s.StringLength };
}

export function mensajeError(err) {
  const msg = err?.message || String(err);
  if (err?.code === "functions/permission-denied") return "Sin permiso: solo administradores.";
  if (err?.code === "functions/unauthenticated") return "Inicia sesión para generar.";
  if (err?.code === "functions/deadline-exceeded") return "La nube tardó demasiado. Intenta de nuevo.";
  if (err?.code === "functions/not-found") return "La función no está desplegada.";
  return msg;
}
